import React from 'react';
import defaultStyles from '../../constants/stylesDefault';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import KobooButton from '../Layout/KobooButton';
import { KOBOO_LIGHT_RED } from '../../constants/colors';
import KobooTextField from '../Layout/KobooTextField';

const SiteLongLocationDuration = (props) => {
  const {
    longLocationTypes,
    longLocationDurations,
    handleAddLongLocationDuration,
    handleRemoveLongLocationDuration,
    handleEditLongLocationDuration
  } = props;

  return (
    <Grid container style={defaultStyles.media}>
      <Grid item xs={12} sm={12} md={12}>
        <Typography
          align="left"
          variant="h6"
          gutterBottom
        >
          Tarif de location
        </Typography>
      </Grid>
      <List>
        {longLocationDurations.map((lld) => {
          return (<ListItem key={`lld_item_${lld.id}`}>
            <FormControl style={{
              width: '200px',
              marginLeft: '8px',
              marginRight: '8px',
              marginTop: '16px',
              marginBottom: '8px'
            }}>
              <InputLabel style={{ width: '200px' }} htmlFor="type">
                {'Durée du forfait'}
              </InputLabel>
              <Select
                value={lld.long_location_type.id}
                onChange={(event) => {
                  let newLld = {...lld};
                  newLld.long_location_type = {id: event.target.value};
                  handleEditLongLocationDuration(newLld, 'llt');
                }}
                name="type"
                style={{ width: '100%' }}
                multiple={false}
              >
                {longLocationTypes.map((llt) => {
                  return (<MenuItem value={llt.id} key={`${lld.id}_${llt.id}`}>
                    {llt.count} {llt.type}
                  </MenuItem>);
                })}
              </Select>
            </FormControl>
            <KobooTextField
              label="Tarif vélo électrique par mois en €"
              type={'number'}
              id={`electric_price_${lld.id}`}
              key={`electric_price_${lld.id}`}
              onChange={event => {
                let newLld = {...lld};
                newLld.electric_price = event.target.value;
                handleEditLongLocationDuration(newLld, 'electric_price');
              }}
              value={lld.is_electric_available ? lld.electric_price : ''}
              width={300}
            />
            <KobooTextField
              label="Tarif vélo mécanique par mois en €"
              type={'number'}
              id={`mechanical_price_${lld.id}`}
              key={`mechanical_price_${lld.id}`}
              onChange={event => {
                let newLld = {...lld};
                newLld.mechanical_price = event.target.value;
                handleEditLongLocationDuration(newLld, 'mechanical_price');
              }}
              value={lld.is_mechanical_available ?lld.mechanical_price : ''}
              width={300}
            />
            <KobooButton
              id={`delete_${lld.id}`}
              type={'button'}
              onClick={() => handleRemoveLongLocationDuration(lld.id)}
              style={{
                backgroundColor: KOBOO_LIGHT_RED,
                width: 'auto',
                marginLeft: '1em',
                padding: '3px 10px'
              }}
            >
              Supprimer
            </KobooButton>
          </ListItem>);
        })}
      </List>
      <Grid item xs={12} sm={12} md={12}>
        <KobooButton type={'button'} onClick={handleAddLongLocationDuration}>
          Ajouter un forfait
        </KobooButton>
      </Grid>
    </Grid>
  );
}

export default SiteLongLocationDuration;



// WEBPACK FOOTER //
// ./src/components/Site/SiteLongLocationDuration.jsx